import { css } from 'styled-components';

export enum FontFamily {
  HalvarBreit = 'HalvarBreit',
}

export enum FontWeight {
  extraBold = '800',
  bold = '700',
  medium = '500',
  regular = '400',
}

interface IFont {
  family?: FontFamily;
  size: number;
  lineHeight: number;
  weight?: FontWeight;
}

export enum TextType {
  extraSmall = 'extraSmall',
  small = 'small',
  normal = 'normal',
  medium = 'medium',
  large = 'large',
  captionSmall = 'captionSmall',
  caption = 'caption',
}

interface IText {
  type?: TextType;
  size?: number;
  weight?: FontWeight;
  lineHeight?: number;
}

class FontService {
  getFontFamily(family: FontFamily) {
    return css`
      font-family: ${family};
    `;
  }

  getFontSize(fontSize: number) {
    return css`
      font-size: ${fontSize}px;
    `;
  }

  getLineHeight(lineHeight: number) {
    return css`
      line-height: ${lineHeight}%;
    `;
  }

  getFontWeight(weight: FontWeight = FontWeight.regular) {
    return css`
      font-weight: ${weight};
    `;
  }

  getFont({
    family = FontFamily.HalvarBreit,
    size,
    lineHeight,
    weight = FontWeight.regular,
  }: IFont) {
    return css`
      ${this.getFontFamily(family)}
      ${this.getFontSize(size)}
      ${this.getLineHeight(lineHeight)}
      ${this.getFontWeight(weight)}
    `;
  }

  text({ type, size, weight, lineHeight }: IText = {}) {
    switch (type) {
      case TextType.extraSmall:
        return css`
          ${this.getFont({ size: 10, lineHeight: lineHeight || 100, weight })}
        `;

      case TextType.small:
        return css`
          ${this.getFont({ size: 12, lineHeight: lineHeight || 100, weight })}
        `;

      case TextType.normal:
        return css`
          ${this.getFont({ size: 16, lineHeight: lineHeight || 100, weight })}
        `;

      case TextType.medium:
        return css`
          ${this.getFont({
            size: 18,
            lineHeight: lineHeight || 100,
            weight: weight || FontWeight.medium,
          })}
        `;

      case TextType.large:
        return css`
          ${this.getFont({ size: 24, lineHeight: lineHeight || 100, weight })}
        `;

      case TextType.captionSmall:
        return css`
          ${this.getFont({
            size: 10,
            lineHeight: lineHeight || 100,
            weight: weight || FontWeight.medium,
          })}
          text-transform: uppercase;
        `;

      case TextType.caption:
        return css`
          display: block;
          ${this.getFont({
            size: 14,
            lineHeight: lineHeight || 150,
            weight: weight || FontWeight.bold,
          })}
          text-align: left;
          text-transform: uppercase;
          letter-spacing: 0.08em;
        `;

      default:
        return css`
          ${this.getFont({ size: size || 16, lineHeight: lineHeight || 150, weight })}
        `;
    }
  }
}

const fontService = new FontService();
export default fontService;
